import { render, staticRenderFns } from "./badgeSilver.vue?vue&type=template&id=425e7403&"
import script from "./badgeSilver.vue?vue&type=script&lang=js&"
export * from "./badgeSilver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports